import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ChooseOrgScreen } from '@/screens/accounts/SCR-109-choose-org'

// SCR-109 Choose an organisation (accounts area).
export const Route = createFileRoute('/_public/choose-org')({
  validateSearch: z.object({ next: z.string().max(2000).optional().catch(undefined) }),
  component: function ChooseOrg() {
    return <ChooseOrgScreen search={Route.useSearch()} />
  },
})
